<template>
    <div>
      <van-sticky :offset-top="0">
        <demo-block :title="('')">
          <van-nav-bar :title="('远程设备排序')" :left-text="('返回')" left-arrow @click-left="this.$router.go(-1)">
            <template #right>
              <van-icon name="home" size="18" />
            </template>
          </van-nav-bar>
        </demo-block>
      </van-sticky>
     
      <div>
        <van-cell 
          v-for="(item, index) in lsGrant"
          :key="item.id"
          class="list-item"
          :draggable="true"
          @dragstart="handleDragStart(index, $event)"
          @dragover.prevent="handleDragOver(index, $event)"
          @drop="handleDrop(index, $event)"
          @touchstart.passive="handleTouchStart(index, $event)"
          @touchmove.prevent="handleTouchMove($event)"
          @touchend="handleTouchEnd($event)"
          :title="`${index + 1}. ${item.termname}`" 
        >
          <template #icon>
            <van-icon name="bars" class="drag-handle"/>
          </template>
        </van-cell>
      </div>
    </div>
  </template>
  
  <script>
  import { Row, Col, Icon, Cell, CellGroup, Form, Field, Button, Popup, Sticky, NavBar, Area, Toast, Calendar, Radio, RadioGroup, Switch } from 'vant';
  import { requestGetGrantTermList, requestUserSaveGrantListOrderNo } from '../../api/api'
  
  export default {
    components: {
      [Row.name]: Row,
      [Col.name]: Col,
      [Icon.name]: Icon,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Form.name]: Form,
      [Field.name]: Field,
      [Button.name]: Button,
      [Popup.name]: Popup,
      [Sticky.name]: Sticky,
      [NavBar.name]: NavBar,
      [Area.name]: Area,
      [Calendar.name]: Calendar,
      [RadioGroup.name]: RadioGroup,
      [Radio.name]: Radio,
      [Switch.name]: Switch,
    },
    data() {
      return {
        lsGrant: [],
        draggedIndex: null,
        isMobile: false,
        currentTouchIndex: false,
        touchStartY: 0
      }
    },
    watch: {},
    computed: {},
    mounted() {
      this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      this.GetGrantTermList()
    },
    methods: {
      async SaveGrantOrderList() {
        const res = await requestUserSaveGrantListOrderNo({accesstoken: this.$store.state.accesstoken,localtoken: this.$store.state.token, data: this.lsGrant})
        console.log(res)
        if (res.return_code ==='0') {
          Toast({
            message: '拖拉完成:' + res.return_message,
            icon: 'success',
          });
        } else 
          Toast({
            message: '排序失败:' + res.return_message,
            icon: 'fail',
          });
      },
      async GetGrantTermList() {
        this.lsGrant=[]
        const res = await requestGetGrantTermList({accesstoken: this.$store.state.accesstoken})
        console.log(res)
        if (res.return_code ==='0') {
          this.lsGrant=res.rows
        }
      },
      handleDragStart (index, event) {
        console.log(event);
        this.draggedIndex = index;
        event.dataTransfer.setData('text/plain', ''); // 必要设置
      },
      // 拖动经过元素
      handleDragOver(index, event) {
        console.log(event,index)
        event.preventDefault();
        if (this.draggedIndex !== index) {
          // 添加视觉反馈
          event.currentTarget.classList.add('drag-over');
        }
      },
      // 放置处理
      handleDrop(targetIndex, event){
        event.preventDefault();
        event.currentTarget.classList.remove('drag-over');
        
        if (this.draggedIndex === null || this.draggedIndex === targetIndex) return;
        
        // 交换数组元素
        const newList = this.lsGrant;
        const movedItem = newList.splice(this.draggedIndex, 1)[0];
        newList.splice(targetIndex, 0, movedItem);
        this.lsGrant = newList;
        // 输出最新顺序
        console.log('当前顺序：', this.lsGrant.map((item, index) => ({
          ...item,
          order: index + 1
        })));
        this.SaveGrantOrderList()
      },
      // 移动端事件
      handleTouchStart(index, event) {
        if (!this.isMobile) return;
        this.currentTouchIndex = index;
        this.touchStartY = event.touches[0].clientY;
        event.currentTarget.classList.add('dragging');
        console.log('start drag ing')
      },
      handleTouchMove(event) {
        if (!this.isMobile || this.currentTouchIndex === null) return;
        
        const touch = event.touches[0];
        const elements = document.elementsFromPoint(touch.clientX, touch.clientY);
        const targetElement = elements.find(el => el.classList.contains('list-item'));
        document.querySelectorAll('.list-item').forEach(el => {
          el.classList.remove('dragging', 'drag-over');
        });
        if (targetElement) {
          targetElement.classList.add('dragging');
          const targetIndex = Array.from(targetElement.parentNode.children).indexOf(targetElement);
          if (targetIndex !== this.currentTouchIndex) {
            this.swapItems(this.currentTouchIndex, targetIndex);
            this.currentTouchIndex = targetIndex;
          }
        }
      },
      handleTouchEnd() {
        if (!this.isMobile) return;
        document.querySelectorAll('.list-item').forEach(el => {
          el.classList.remove('dragging', 'drag-over');
        });

        this.SaveGrantOrderList()
        this.currentTouchIndex = null;
      },
      swapItems(fromIndex, toIndex) {
        if (fromIndex === toIndex) return;
        const newList = this.lsGrant
        // const movedItem = newList.splice(this.draggedIndex, 1)[0];
        const movedItem = newList.splice(fromIndex, 1)[0];
        newList.splice(toIndex, 0, movedItem);
        this.lsGrant = newList;
        console.log('当前顺序：', 
          this.lsGrant.map((item, index) => ({
            ...item,
            order: index + 1
          }))
        )
      }
    }
  }
  </script>
  
  <style lang="less">
  .list-item {
    transition: transform 0.3s;
    cursor: move;
  }

  .drag-handle {
    margin-right: 12px;
    color: #969799;
  }

  .drag-over {
    border-top: 2px solid #07c160;
    margin-top: -2px;
  }

  /* 拖动时的预览样式 */
  .list-item[draggable="true"]:active {
    opacity: 0.8;
  }
  /* 移动端拖动时的视觉效果 */
  .list-item.dragging {
    transition: none; /* 禁用过渡避免拖影 */
    z-index: 9999;
    background: rgb(230, 221, 221);
    box-shadow: 0 3px 15px rgba(0,0,0,0.2);
    transform: scale(1.02) rotate(1deg);
  }

  /* 防止移动端长按菜单 */
  .list-item {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
  }
  .user {
    &-poster {
      width: 100%;
      height: 53vw;
      display: block;
    }
  
    &-group {
      margin-bottom: 15px;
    }
  
    &-links {
      padding: 15px 0;
      font-size: 12px;
      text-align: center;
      background-color: #fff;
  
      .van-icon {
        display: block;
        font-size: 24px;
      }
    }
  }
  </style>
  